import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import jspdf from 'jspdf';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { PopoverController } from '@ionic/angular'
import { OpcionesExportarComponent } from 'src/app/componentes/opciones-exportar/opciones-exportar.component';


@Component({
  selector: 'app-documentos-pendientes',
  templateUrl: './documentos-pendientes.component.html',
  styleUrls: ['./documentos-pendientes.component.scss'],
})
export class DocumentosPendientesComponent implements OnInit {

  Fecha = { Fecha1: "", Fecha2: "" }
  @Output() desabilitar = new EventEmitter();
  disabled: boolean = true;
  @Input() UserID = ""
  Documentos = []
  @Output() recargar = new EventEmitter();
  @Output() correo = new EventEmitter();

  @Input() permiteMensaje = true;

  @ViewChild('pdfTable') pdfTable: ElementRef;
  @Input() HijosPreCargados = []
  @Input() PrecargarHijos = false;

  HijosSeleccionados = []

  MostrarMenu = false

  filtro = ""
  filtrado = false;
  pdf: string = ""
  constructor(private conexion: ConexionService, private utilidades: UtilidadesService,
    private popoverController: PopoverController) {



  }
  HijosSelect = []
  Copia = ""


  ngOnChanges(): void {
    if(this.PrecargarHijos){
      let hs = []

      for (let i of this.HijosPreCargados) {
        hs.push({
          Nombre: i.Nombre1 + " " + i.Apellido1,
          Foto: "https://ofdpinternacional.com/wp-content/uploads/2018/09/5.jpg", Value: i.Id
        })
      }

      this.HijosSelect = hs
    }
  }

  ngOnInit() {
    if (!this.PrecargarHijos) {
      this.getTodosLosHijosDeFamilias()
    } 
    setTimeout(() => {
      this.getDocumentosPendientesDePagoFamiliasVinculadasAMi()
    }, 150);




  }

  getTodosLosHijosDeFamilias() {
    let familias = JSON.parse(atob(localStorage.getItem(btoa("Familias"))))
    let fams = []
    for (let i of familias) {
      console.log(i)
      fams.push(i.CodigoFamilia)
    }
    this.conexion.getTodosLosHijosDeFamilias(fams.toString()).subscribe((resp) => {
      let hs = []

      for (let i of resp.Datos) {
        hs.push({
          Nombre: i.Nombre1 + " " + i.Apellido1,
          Foto: "https://ofdpinternacional.com/wp-content/uploads/2018/09/5.jpg", Value: i.Id
        })
      }

      this.HijosSelect = hs

    })
  }

  async Exportar(e: Event) {
    const popover = await this.popoverController.create({
      component: OpcionesExportarComponent,
      event: e,
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();

    this.utilidades.Depuracion(data, "console", "")
    if (data == "pdf") {
      this.pdfF()
    } else if (data == "excel") {
      this.exportexcel()
    }
  }


  getDocumentosPendientesDePagoFamiliasVinculadasAMi() {
    this.getFacturasFamilia2()
    return 0;

  }

  aa(a) {
    console.log(a)
  }

  getFacturasFamilia2(val = true) {
    this.conexion.getFacturasFamilia2(this.UserID,
      this.Fecha.Fecha1, this.Fecha.Fecha2).subscribe((resp) => {
        this.desabilitar.emit(false)
        this.disabled = false;
        this.utilidades.Depuracion(resp, "console", "")
        if (resp.Respuesta == "Exito") {
          this.Documentos = resp.Datos
          this.utilidades.Depuracion(resp.Datos, "console", "")


          setTimeout(() => {
            this.Copia = JSON.stringify(this.Documentos)
          }, 100);

          this.MostrarMenu = true
        }
      }, (err) => {
        // this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
        if (this.permiteMensaje) {
          this.utilidades.Alerta("En estos momentos este servicio no se encuentra disponible. Por favor, inténtelo más tarde.")
        }
        this.permiteMensaje = true
        this.desabilitar.emit(true)
        this.disabled = true;
        this.utilidades.ValidarUser(err)
      })
  }

  EstaHijo(idest, arr) {

    for (let i of arr) {
      if (String(idest) == String(i.Id)) {
        return true;
      }
    }
    return false;
  }

  EnArreglo(valor, arreglo) {
    for (let i of arreglo) {
      if (Number(valor) == Number(i)) {
        return true;
      }
    }

    return false;
  }

  Sumar(array, key): number {
    let total: number = 0
    for (let i of array) {
      if ((this.EnArreglo(i.idEstudiante, this.HijosSeleccionados))) {
        total += Number(i[key])
      }
    }
    return total
  }

  CalcularBalance(array): number {
    let total: number = 0
    for (let i of array) {
      if ((this.EnArreglo(i.idEstudiante, this.HijosSeleccionados))) {
        total += Number(i.montoPendienteTotal)
      }
    }
    return total
  }

  FiltroPorConcepto() {
    this.filtrado = true;
    let cuantas = 0
    this.Documentos = JSON.parse(this.Copia)
    for (let familia in this.Documentos) {
      for (let estudiante in this.Documentos[familia].Estudiantes) {
        while (this.Documentos[familia].Estudiantes[estudiante].Documentos.some(documento2 =>
          String(documento2.concepto).toLocaleLowerCase().indexOf(this.filtro.toLocaleLowerCase()) == -1)) {

          for (let documento in this.Documentos[familia].Estudiantes[estudiante].Documentos) {
            if (this.Documentos[familia].Estudiantes[estudiante].Documentos[documento].concepto
              .indexOf(this.filtro) == -1) {
              this.Documentos[familia].Estudiantes[estudiante].Documentos.splice(documento, 1)
            }
          }
        }
        if (this.Documentos[familia].Estudiantes[estudiante].Documentos.length == 0) {
          cuantas += 1
        }
      }
    }

    for (let familia in this.Documentos) {
      for (let estudiante = 0; estudiante < this.Documentos[familia].Estudiantes.length; estudiante++) {
        if (this.Documentos[familia].Estudiantes[estudiante].Documentos.length == 0) {
          this.Documentos[familia].Estudiantes.splice(estudiante, 1)
          estudiante--;
        }
      }

    }

  }

  exp = "TablaExportar"
  excel = false
  exportexcel(): void {
    this.exp = ""
    this.excel = true;
    this.utilidades.Toast("Descargando Excel...", 3000, "download-outline")
    setTimeout(() => {
      // /* table id is passed over here */
      // let element = document.getElementById('datos');
      // const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      // /* generate workbook and add the worksheet */
      // const wb: XLSX.WorkBook = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // /* save to file */
      // XLSX.writeFile(wb, "Documentos pendientes  " + String(new Date()) + ".xlsx");


      const downloadLink = document.createElement("a");
      const dataType = 'application/vnd.ms-excel';
      const table = document.getElementById("datos");
      const tableHtml = table.outerText.replace(/ /g, '%20')
      document.body.appendChild(downloadLink);
      downloadLink.href = 'data:' + dataType + ' ' + tableHtml;
      downloadLink.download = "Documentos pendientes " + String(new Date()) + ".xls";
      downloadLink.click();

      this.exp = "TablaExportar"
      this.excel = false
    }, 150);
  }

  Totales(key) {
    let total = 0
    for (let fams of this.Documentos) {
      for (let estudiantes of fams.Estudiantes) {
        total += Number(this.Sumar(estudiantes.Documentos, key))
      }
    }

    return total
  }

  TotalBalance() {
    let total = 0
    for (let fams of this.Documentos) {
      for (let estudiantes of fams.Estudiantes) {
        total += Number(this.CalcularBalance(estudiantes.Documentos))
      }
    }

    return total
  }

  pdfF() {
    this.utilidades.Toast("Descargando PDF...", 3000, "download-outline")
    let d = document.getElementById("imprimible")
    d.innerHTML = this.TextoMostrablePDF()
    this.pdf = "pedefeable"
    document.getElementById("cc").scrollTo({ top: 0, behavior: "smooth" })

    setTimeout(() => {
      let pd = new jspdf('p', 'pt', 'letter')
      pd.html(this.pdfTable.nativeElement, {
        "margin": [25, 0, 25, 0], "autoPaging": "text",
        callback: (pdf) => {
          pdf.save("Documentos pendientes  " + String(new Date()) + ".pdf")
          setTimeout(() => {
            d.innerHTML = ""
            this.pdf = ""
          }, 800);
        }
      })
    }, 100);

  }

  TextoMostrable() {
    let text = '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title>Documentos pendientes</title> <style> *{font-family: "Arial", sans-serif !important;} .divTablaExport{max-width: 1024px; min-width: 260px;} .h3{margin: 20px 2px 2px 2px; font-size: 22px;} table{ border-collapse:separate; width: 100%; table-layout: fixed;} .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 15px;} .table_header th:last-child{ border-right: 1px solid black; border-top-right-radius: 5px; border-bottom-right-radius: 5px; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px; border-bottom-left-radius: 5px; } .tdcantdocs{ padding: 5px 0; border-bottom: 1px solid black; border-top: 1px solid black; text-align: center; font-size: 15px;} td{ text-align: left; font-size: 16px;} .tdImp{ text-align: left; font-size: 15px; width: 90px !important;} .tdImpC{ text-align: left; font-size: 15px; width: 255px !important;} .thImp2{padding: 0 10px; font-size: 1px !important; color:transparent;  text-align: center; width:90px;} .thImp{padding: 7px 10px; font-size: 15px; text-align: center; width:90px;} .thImpC2{padding: 0 10px; font-size: 1px; color:transparent;  text-align: center; width:255px;} .thImpC{padding: 7px 10px; font-size: 15px; text-align: center; width:255px;} .tdEstudianteF{font-size: 14px !important;} .tdEstudiante{font-size: 14px !important;} .bEstudiante{ font-size: 14px; font-weight: bold !important;} </style> </head> <body> <div style="text-align: center;"> <h3 class="h3"> INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </h3> <p style="font-size: 15px; margin: 3px 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 18px; margin: 5px 1px;"> <b> Cuentas por Cobrar Pendientes al {{FechaHasta}} </b> </p> <p style="font-size: 14px; margin: 5px 1px;"> <b>Desde:</b>  {{FechaDesde}} <b style="margin-left: 5px;">Hasta:</b> {{FechaHasta}}  </p> </div> <br> <p style="font-size: 15px; font-style: italic; font-weight: bold;"> <b>Agrupadas por Familias-Estudiantes (Incluye Solo Familias Comunes)</b> </p> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML).replace("{{FechaDesde}}", this.Fecha.Fecha1).replace("{{FechaHasta}}", this.Fecha.Fecha2).replace("{{FechaHasta}}", this.Fecha.Fecha2)

    return text
  }

  TextoMostrablePDF() {
    let text = '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title>Documentos pendientes</title> <style> *{font-family: "Arial", sans-serif !important; letter-spacing: 0.1px;} .h3{margin: 20px 2px 2px 2px; font-size: 13px; font-weight: bold;} table{ border-collapse:separate; width: 100%; table-layout: fixed;} .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 7px;} .table_header th:last-child{ border-right: 1px solid black; border-top-right-radius: 4px !important; border-bottom-right-radius: 4px !important; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 4px !important; border-bottom-left-radius: 4px !important; } .tdcantdocs{ padding: 5px 0; border-bottom: 1px solid black; border-top: 1px solid black; text-align: center; font-size: 11px;} .tdImp{ text-align: left; font-size: 16px; width: 70px;}  .tdImpC{ text-align: left; font-size: 12px; width: 115px;} .thImp{padding: 7px 10px; font-size: 9px !important; text-align: center; width: 70px;} .thImpC2{padding: 0 10px !important; font-size: 1px; color:transparent;  text-align: center; width:115px;} .thImp2{padding: 0 10px !important; font-size: 1px !important; color:transparent;  text-align: center; width: 70px;} .thImpC{padding: 7px 10px; font-size: 9px !important; text-align: center; width:115px} td{  text-align: left; font-size: 9px !important;} .trPrevDocs{padding-bottom: 15px;} .tdEstudianteF{font-size: 9px !important;} .bEstudiante{ font-size: 9px !important; font-weight: bold !important;} </style> </head> <body> <div style="text-align: center;"> <h3 class="h3"> INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </h3> <p style="font-size: 9px; margin: 3px 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 11px; margin: 5px 1px;"> <b> Cuentas por Cobrar Pendientes al {{FechaHasta}} </b> </p> <p style="font-size: 9px; margin: 5px 1px;"> <b>Desde:</b>  {{FechaDesde}} <b style="margin-left: 5px;">Hasta:</b> {{FechaHasta}}  </p> </div> <br> <p style="font-size: 9px; font-style: italic; font-weight: bold;"> <b>Agrupadas por Familias-Estudiantes (Incluye Solo Familias Comunes)</b> </p> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML).replace("{{FechaDesde}}", this.Fecha.Fecha1).replace("{{FechaHasta}}", this.Fecha.Fecha2).replace("{{FechaHasta}}", this.Fecha.Fecha2)

    return text
  }

  Imprimir() {

    let vent = window.open('', '', 'height=800, width=800');
    vent.document.write(this.TextoMostrable())
    vent.document.close()
    setTimeout(() => {
      vent.print()
    }, 300);

  }

  TieneDocumentos(fam): boolean {
    for (let j of fam.Estudiantes) {
      if (j.Documentos.length > 0 && this.EnArreglo(j.IdEst, this.HijosSeleccionados)) {
        return true;
      }
    }


    return false
  }

  ContarDocumentosFamilia(familia) {
    let total = 0;

    for (let i of familia.Estudiantes) {
      if (this.TieneDocumentos(familia)) {
        for (let d of i.Documentos) {
          for (let v of this.HijosSeleccionados) {
            if (String(d.idEstudiante) == String(v)) {
              total += 1
            }
          }

        }

      }
    }

    return total
  }

  SumarBalance(familia) {
    let total = 0;

    for (let i of familia.Estudiantes) {
      if (this.TieneDocumentos(familia)) {
        total += this.CalcularBalance(i.Documentos)
      }
    }

    return total
  }

  SumarDocumentosFamilia(familia, key) {
    let total = 0;

    for (let i of familia.Estudiantes) {
      if (this.TieneDocumentos(familia)) {
        total += this.Sumar(i.Documentos, key)
      }
    }

    return total
  }

  HayDatos(): boolean {
    if (document.getElementById("datos")) {
      if (document.getElementById("datos").innerText.length > 160) {
        return true;
      }
    }
    return false;
  }

}

